import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { HAMBURGER_TOGGLE_ID, MOBILE_NAV_MENU_ID } from './util';
import styles from './Hamburger.module.less';
import { trackGA } from 'services/track';

export default function Hamburger({ open = false }) {
  const onClick = () => {
    document.dispatchEvent(new Event('toggleMobileNavMenu'));
    if (!open) {
      const gtmObject = {
        event: 'open_hamburger_menu',
        feature: 'Navigation',
        section: 'Main Menu',
        button: 'Hamburger menu',
      };
      trackGA('hamburger', 'click_button', '', '', gtmObject);
    }
  };

  return (
    <button
      className={clsx(
        styles.hamburger,
        styles.hamburgerSlider,
        styles.mobileOnly,
        open && styles.open
      )}
      onClick={onClick}
      id={HAMBURGER_TOGGLE_ID}
      type="button"
      aria-controls={MOBILE_NAV_MENU_ID}
      aria-label={open ? 'Close' : 'Main menu'}
      aria-expanded={open}
      title="Main menu"
    >
      <span className={styles.hamburgerBox}>
        <span className={styles.hamburgerInner} />
        <span className={clsx(styles.hamburgerInner, styles.thirdLine)} />
      </span>
    </button>
  );
}

Hamburger.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
};
